import { Box, Chip, Typography } from '@mui/material';
import { TicketGatewayType } from '../ticket.types';

const gatewayTitle = (gateway: TicketGatewayType) => {
    if (gateway.title && gateway.website) {
        return `${gateway.title} (${gateway.website})`;
    }

    return gateway.title || gateway.website || `درگاه #${gateway.id}`;
};

export const TicketGatewayOption = ({
    gateway,
}: {
    gateway: TicketGatewayType;
}) => {
    const accessLabel = gateway.is_owner
        ? undefined
        : gateway.access_display_name?.trim();

    return (
        <Box
            component="span"
            sx={{
                width: '100%',
                minWidth: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
            }}>
            <Typography
                component="span"
                variant="body2"
                noWrap
                sx={{ minWidth: 0, flex: 1 }}>
                {gatewayTitle(gateway)}
            </Typography>

            {accessLabel ? (
                <Chip
                    component="span"
                    size="small"
                    variant="outlined"
                    label={accessLabel}
                    sx={{
                        flexShrink: 0,
                        height: 24,
                        '& .MuiChip-label': {
                            px: 1,
                            fontSize: '0.72rem',
                        },
                    }}
                />
            ) : null}
        </Box>
    );
};

export default TicketGatewayOption;
